export default {
  contact: {
    title: '@:contact_section.card_title',
    title_message: '未登録の方へ',
    description_1: '調査回答依頼を受けた企業名を記載の上、下記までお問い合わせください。',
    description_2: '1営業日以内にご連絡いたします。',
    contact_to_text: 'お問い合わせ先',
    copied_message: 'メールアドレスをコピーしました。',
  },
}
